import { render, staticRenderFns } from "./topNavMenu.vue?vue&type=template&id=99654524&scoped=true&"
import script from "./topNavMenu.vue?vue&type=script&lang=js&"
export * from "./topNavMenu.vue?vue&type=script&lang=js&"
import style0 from "./topNavMenu.vue?vue&type=style&index=0&id=99654524&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99654524",
  null
  
)

export default component.exports